<script setup>
import { postRequest, putRequest } from "@/utils/request.js";
import { message } from "ant-design-vue";
import { reactive, ref, unref } from "vue";

const emit = defineEmits(["ok"]);
const title = ref("");
const open = ref(false);
const confirmLoading = ref(false);

let formModel = ref({});
const formRef = ref();

const rules = reactive({
  name: [
    {
      required: true,
      message: "请输入名称",
      trigger: "blur",
    },
  ],
  k: [
    {
      required: true,
      message: "请输入键",
      trigger: "blur",
    },
  ],
  v: [
    {
      required: true,
      message: "请输入值",
      trigger: "blur",
    },
  ],
});

const handleAdd = () => {
  handleEdit({});
};

const handleEdit = (record) => {
  formModel.value = Object.assign(
    {},
    {
      ...record,
    },
    {
      phone: null,
      oldPhone: record.phone,
    },
  );
  open.value = true;
  if (formModel.value.id) {
    if (formModel.value.oldPhone) {
      rules.phone[0].required = false;
    }
    rules.password[0].required = false;
  }
};

const handleClose = () => {
  open.value = false;
  formRef.value.resetFields();
};

const handleConfirm = async () => {
  formRef.value.validate().then(async () => {
    const unrefFormModel = unref(formModel);
    let request;
    if (unrefFormModel.id) {
      request = putRequest;
    } else {
      request = postRequest;
    }
    request("/systemSetting", unrefFormModel).then((response) => {
      if (response.success) {
        message.success("保存成功");
        emit("ok");
        handleClose();
      } else {
        message.error("保存失败。" + response.message);
      }
    });
  });
};

defineExpose({
  handleAdd,
  handleEdit,
  handleClose,
  title,
});
</script>

<template>
  <a-modal
    width="800px"
    :open="open"
    :title="title"
    :confirm-loading="confirmLoading"
    @cancel="handleClose"
    @ok="handleConfirm"
  >
    <a-form
      ref="formRef"
      :labelCol="{ span: 3 }"
      :wrapperCol="{ span: 24 }"
      :model="formModel"
      :rules="rules"
    >
      <a-form-item label="名称" name="name">
        <a-input
          v-model:value="formModel.name"
          autocomplete="off"
          placeholder="请输入名称"
        />
      </a-form-item>
      <a-form-item label="键" name="k">
        <a-input v-model:value="formModel.k" placeholder="请输入键" />
      </a-form-item>
      <a-form-item label="值" name="v">
        <a-input v-model:value="formModel.v" placeholder="请输入键" />
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<style scoped lang="scss"></style>
